import * as R from 'ramda'
import * as recompose from 'recompose'
import PropTypes from 'prop-types'

import * as configuration from '../configuration'
import { ClientType } from '../constants'

import { LiveCasinoQuery as Component } from './live-casino-query'

export const LiveCasinoQuery = R.compose(
  configuration.withClientType,
  recompose.setPropTypes({
    clientType: PropTypes.oneOf([
      ClientType.BROWSER,
      ClientType.MOBILE_BROWSER,
      ClientType.UNKNOWN,
    ]).isRequired,
  }),
  recompose.branch(
    props => R.equals(props.clientType, ClientType.UNKNOWN),
    recompose.renderNothing
  )
)(Component)
